import {Injectable, inject} from '@angular/core'
import {MultioptionInput} from '@models/multioption-input'
import {OrderStatusCodes, OrderStatuses} from '@models/order/order'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {OrderStatusService} from './order-status.service'

/**
 * Variante embebida de `OrderStatusService`.
 *
 * @description
 * En modo embebido el selector de estado no se muestra (lo gestiona el host). Devuelve
 * array vacío en `getOrderMultiOptionButton` y fuerza `LISTO` como estado por defecto
 * al enviar al host.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderStatusEmbeddedService extends OrderStatusService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)

  override getOrderMultiOptionButton = (): MultioptionInput[] => {
    return []
  }

  override getDefaultOption = (): MultioptionInput => ({
    key: OrderStatusCodes.LISTO,
    label: this.translateKeys[OrderStatuses.AC.label],
    defaultValue: true,
    color: OrderStatuses.AC.color,
  })
}
